import React from 'react';

const Input = ({
  label,
  id,
  name,
  type = 'text',
  value,
  onChange,
  placeholder = '',
  required = false,
  disabled = false,
  error = '',
  mask = null,
  maxLength,
  min,
  max,
  step,
  className = '',
}) => {
  const handleChange = (e) => {
    const { value: inputValue } = e.target;
    
    if (mask === null) {
      // Sem máscara, passar o valor normalmente
      onChange(e);
      return;
    }
    
    // Aplicar máscara para CPF: 999.999.999-99
    if (mask === '999.999.999-99') {
      // Remover todos os caracteres não numéricos
      const numbers = inputValue.replace(/\D/g, '');
      
      // Limite de 11 dígitos para CPF
      const limitedNumbers = numbers.slice(0, 11);
      
      // Formatar o CPF
      let formattedValue = '';
      
      if (limitedNumbers.length > 0) {
        formattedValue = limitedNumbers.slice(0, 3);
        
        if (limitedNumbers.length > 3) {
          formattedValue += '.' + limitedNumbers.slice(3, 6);
        }
        
        if (limitedNumbers.length > 6) {
          formattedValue += '.' + limitedNumbers.slice(6, 9);
        }
        
        if (limitedNumbers.length > 9) {
          formattedValue += '-' + limitedNumbers.slice(9, 11);
        }
      }
      
      // Criar um evento sintético para passar o valor formatado
      const syntheticEvent = {
        ...e,
        target: {
          ...e.target,
          value: formattedValue,
          name: e.target.name
        }
      };
      
      onChange(syntheticEvent);
      return;
    }
    
    // Máscara para CNPJ: 99.999.999/9999-99
    if (mask === '99.999.999/9999-99') {
      // Remover todos os caracteres não numéricos
      const numbers = inputValue.replace(/\D/g, '');
      
      // Limite de 14 dígitos para CNPJ
      const limitedNumbers = numbers.slice(0, 14);
      
      // Formatar o CNPJ
      let formattedValue = '';
      
      if (limitedNumbers.length > 0) {
        formattedValue = limitedNumbers.slice(0, 2);
        
        if (limitedNumbers.length > 2) {
          formattedValue += '.' + limitedNumbers.slice(2, 5);
        }
        
        if (limitedNumbers.length > 5) {
          formattedValue += '.' + limitedNumbers.slice(5, 8);
        }
        
        if (limitedNumbers.length > 8) {
          formattedValue += '/' + limitedNumbers.slice(8, 12);
        }
        
        if (limitedNumbers.length > 12) {
          formattedValue += '-' + limitedNumbers.slice(12, 14);
        }
      }
      
      // Criar um evento sintético para passar o valor formatado
      const syntheticEvent = {
        ...e,
        target: {
          ...e.target,
          value: formattedValue,
          name: e.target.name
        }
      };
      
      onChange(syntheticEvent);
      return;
    }
    
    // Máscara para CEP: 99999-999
    if (mask === '99999-999') {
      // Remover todos os caracteres não numéricos
      const numbers = inputValue.replace(/\D/g, '');
      
      // Limite de 8 dígitos para CEP
      const limitedNumbers = numbers.slice(0, 8);
      
      // Formatar o CEP
      let formattedValue = '';
      
      if (limitedNumbers.length > 0) {
        formattedValue = limitedNumbers.slice(0, 5);
        
        if (limitedNumbers.length > 5) {
          formattedValue += '-' + limitedNumbers.slice(5, 8);
        }
      }
      
      // Criar um evento sintético para passar o valor formatado
      const syntheticEvent = {
        ...e,
        target: {
          ...e.target,
          value: formattedValue,
          name: e.target.name
        }
      };
      
      onChange(syntheticEvent);
      return;
    }
    
    // Caso não seja nenhuma das máscaras específicas, passa o valor normalmente
    onChange(e);
  };

  return (
    <div className="flex flex-col">
      {label && (
        <label 
          htmlFor={id} 
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      
      <input
        id={id}
        name={name}
        type={type}
        value={value || ''}
        onChange={handleChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        maxLength={mask ? undefined : maxLength}
        min={min}
        max={max}
        step={step}
        autoComplete="off"
        className={`
          block w-full rounded-md border-gray-300 shadow-sm 
          focus:border-primary focus:ring-primary sm:text-sm
          ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}
          ${error ? 'border-red-500' : ''}
          ${className}
        `}
      />
      
      {error && (
        <p className="mt-1 text-sm text-red-500">{error}</p>
      )}
    </div>
  );
};

export default Input;